import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap/lib'
import API from '../../utils/api'
import numeral from 'numeral'
import avatar from '../../assets/images/avatar-100.png'
import cash from '../../assets/images/cash1-50.png'
import VerificationInput from 'react-verification-input'
import styled from 'styled-components'
import { Iconify } from '../../Xmerald-UI'
import './SMSCode.css'

const SmsPanel = styled.div`
  border: 1px solid #232323;
  border-radius: 10px;
  padding: 10px;
  margin: 15px 10px;
`

export const ConfirmationTransfer = ({
  closeConfirmation,
  show,
  userToTransfer,
  amountToTransfer,
  submitting,
  updateUserBalance,
  updateUserAvailable
}) => {
  const [status, setStatus] = useState('IDLE')
  const [verificationCode, setVerificationCode] = useState('')
  const [successfullTransaction, setSuccessfullTransaction] = useState(false)

  if (!show) return null

  const handleClose = () => {
    setStatus('IDLE')
    setVerificationCode('')
    setSuccessfullTransaction(false)
    closeConfirmation()
  }

  const getStatusButtonText = () => {
    const statusTexts = {
      SENDING_SMS: 'CONFIRMAR CODIGO',
      IDLE: 'ENVIAR SMS',
      ERROR_SENDING_SMS: 'REENVIAR SMS',
      ERROR_SMS_CODE: 'REINTENTAR',
      LOADING: <i className='ion-load-a' />
    }
    return statusTexts[status]
  }

  const handleSMSRequest = async () => {
    setStatus('LOADING')
    try {
      const response = await API.requestSMSCodeForTransfer()
      if (!response.data.success) {
        setStatus('ERROR_SENDING_SMS')
        return
      }
      setStatus('SENDING_SMS')
    } catch (error) {
      setStatus('ERROR_SENDING_SMS')
    }
  }

  const handleTransferConfirm = async () => {
    setStatus('LOADING')
    try {
      const response = await API.requestTransferConfirm({
        otp: verificationCode,
        user: { id: userToTransfer.id },
        amount: amountToTransfer
      })

      if (!response.data.success) {
        setStatus('ERROR_SMS_CODE')
        return
      }

      setSuccessfullTransaction(true)
      updateUserBalance(response.data.balance)
      updateUserAvailable(response.data.availableForCashout)
    } catch (error) {
      setStatus('ERROR_SMS_CODE')
    }
  }

  const buttonAction = () => {
    if (['IDLE', 'ERROR_SENDING_SMS'].includes(status)) {
      handleSMSRequest()
    } else if (['SENDING_SMS', 'ERROR_SMS_CODE'].includes(status)) {
      handleTransferConfirm()
    }
  }

  const renderContent = () => {
    if (successfullTransaction) {
      return (
        <div className='flex-container column justify align'>
          <div className='mt-2'>
            <i className='ion-checkmark-circled success' />
          </div>
          <div className='flex-col col-center text-center mb-2'>
            Tú transferencia se completó con éxito.
          </div>
        </div>
      )
    }

    return (
      <div className='flex-container column'>
        <div className='flex-row'>
          <div className='flex-col'>
            <div className='nota text-sm'>
              Por favor asegurate que los datos del usuario al que le vas a transferir saldo sean correctos.
            </div>
            <div className='nota'>
              Las transferencias de saldo son finales e irreversibles.
            </div>
            <div className='flex-row' style={{ margin: '10px 0' }}>
              <div className='flex-container justify align'>
                <img
                  src={userToTransfer.avatar ? `${userToTransfer.avatar_dir}${userToTransfer.avatar}` : avatar}
                  className='transfer-avatar'
                  alt=''
                />
              </div>
              <div className='flex-col col-center'>
                <div className='flex-container justify align' style={{ fontSize: '1.2em' }}>
                  {userToTransfer.nick}
                </div>
                <div className='balance real flex-container justify align'>
                  <img src={cash} className='balance-icons' alt='' />
                  <span className='balance-real'>
                    {numeral(amountToTransfer).format('$0,000.00')} MXN
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='flex-container align justify'>
          Este monto pasará a ser saldo no retirable en la cuenta que reciba la transferencia.
        </div>

        {status === 'ERROR_SENDING_SMS' && (
          <div className='flex-container column justify align text-warning' style={{ color: 'orangered' }}>
            <Iconify icon='bx:error-alt' mt={10} size={19} />
            <div className='flex-col col-center text-center'>
              Lo sentimos encontramos un error al enviar el SMS
            </div>
          </div>
        )}

        {['SENDING_SMS', 'ERROR_SMS_CODE'].includes(status) && (
          <SmsPanel className='flex-container column'>
            <div className='flex-col text-center primary' style={{ color: '#78bc28' }}>
              Te enviaremos un código por SMS para verificar la transferencia.
            </div>

            {status === 'ERROR_SMS_CODE' && (
              <div className='flex-container column justify align text-warning' style={{ color: 'orangered' }}>
                <Iconify icon='bx:error-alt' mt={10} size={19} />
                <div className='flex-col col-center text-center'>
                  El código es incorrecto o ya no es válido
                </div>
              </div>
            )}

            <div style={{ width: 300, margin: '1em auto' }}>
              <VerificationInput
                placeholder=''
                validChars='0-9'
                inputProps={{ type: 'tel' }}
                length={5}
                autoFocus
                value={verificationCode}
                onChange={setVerificationCode}
                classNames={{
                  container: 'sms-container',
                  character: 'character',
                  characterInactive: 'character--inactive',
                  characterSelected: 'character--selected'
                }}
              />
            </div>
          </SmsPanel>
        )}

        <div className='flex-row btn-wrap'>
          <Button className='btn-rojo flex-col col-40 col-5' onClick={handleClose}>
            CANCELAR
          </Button>
          <Button
            className='btn-pick flex-col col-40 col-offset-10'
            disabled={submitting}
            onClick={buttonAction}
          >
            {getStatusButtonText()}
          </Button>
        </div>
      </div>
    )
  }

  return (
    <Modal
      keyboard
      bsSize='small'
      backdropClassName='confirmationTransferBackdrop'
      show={show}
      onHide={handleClose}
    >
      <div className='transactionPanel panel-pickwin'>
        <div id='panelTitle' className='panel-abonar-titulo'>
          <button className='cerrar-panel' onClick={handleClose}>
            <div className='btn-icon-close'>
              <i className='ion-ios-close-empty' />
            </div>
          </button>
        </div>
        <div className='exchangeContainer col-xs-10 col-xs-offset-1'>
          {renderContent()}
        </div>
      </div>
    </Modal>
  )
}